import { Paper, H1, H4 } from "../../../styled";
import { Divider } from "@mui/material";


const ChangePayrateForm = () => {
  return (
    <div
      style={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        margin: "30px",
      }}
    >
      <Paper>
        <div style={{ padding: "20px" }}>
          <H4> Change compensation plan </H4>
          <Divider />
          <H4>Change compensation plan</H4>
        </div>
      </Paper>
    </div>
  );
};

export default ChangePayrateForm;
